import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/services-usa/mobile-app/augmented_mob.webp";
import { Link } from "gatsby";

function Augmentedmobileapp() {
  return (
    <section
      className="augmentedmobileapp"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} className="my-auto">
            <h2 style={{ color: "#fff" }}>
              Accelerate <span>Mobile App Launch</span> with TekRevol
            </h2>
            <p style={{ color: "#fff" }}>
              Got an app idea? We’ve you covered with instant MVP development
              followed by full-stack, custom mobile app development services.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Build My App
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} className="text-center">
            <div className="winning_image">
              <StaticImage
                src="../../images/services-usa/mobile-app/aug_mob_img.webp"
                alt="mobile app development company"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={617}
                height={590}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Augmentedmobileapp;
